export default __webpack_public_path__ + "static/Metropolis-ExtraBold-dac837f8bde3fcfe8a842b614b4646fc.woff2";